export default __webpack_public_path__ + "static/logo-cbc032cd6c169ee11b2661009e18ce1e.png";